import React from "react";
import { Card } from "antd";
import styled from "styled-components";

const AnalyticsCardWrapper = styled(Card)`
  border: none;
  border-radius: 12px;
  background-color: ${(props) => props.bgColor || "var(--primary-bg)"};
  transition: all 0.3s ease;
  height: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  .ant-card-body {
    padding: 24px;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

const CardIcon = styled.div`
  font-size: 32px;
  color: ${(props) => props.iconColor || "var(--primary-text-color)"};
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 1;
`;

const CardValue = styled.div`
  font-size: 36px;
  font-weight: 700;
  color: ${(props) => props.valueColor || "var(--primary-text-color)"};
  margin-bottom: 8px;
  line-height: 1.2;
`;

const CardTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.valueColor || "var(--primary-text-color)"};
  margin-bottom: 0;
  line-height: 1.4;
`;

const CardSubtitle = styled.div`
  font-size: 12px;
  color: ${(props) => props.valueColor || "var(--secondary-text-color)"};
  margin-top: 4px;
  opacity: 0.8;
  line-height: 1.4;
`;

const AnalyticsCard = ({ icon, value, title, subtitle, bgColor, iconColor, valueColor }) => {
  return (
    <AnalyticsCardWrapper bgColor={bgColor}>
      <CardIcon iconColor={iconColor}>{icon}</CardIcon>
      <CardValue valueColor={valueColor}>{value}</CardValue>
      <CardTitle valueColor={valueColor}>{title}</CardTitle>
      {subtitle && <CardSubtitle valueColor={valueColor}>{subtitle}</CardSubtitle>}
    </AnalyticsCardWrapper>
  );
};

export default AnalyticsCard;

